import { afterNextRender, DestroyRef, Injector } from '@angular/core';

export const afterNextRenderSafe = (
  callback: VoidFunction,
  injector: Injector
) => {
  if (injector.get(DestroyRef).destroyed) {
    return;
  }

  afterNextRender(callback, { injector });
};
